module.exports = __webpack_public_path__ + "img/img1.d248e927.png";